import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { Box, Drawer, Hidden, List, makeStyles } from '@material-ui/core';
import { GlobalContext } from '/context';
import CloseIcon from '@material-ui/icons/Close';

import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';

const useStyles = makeStyles((theme) => ({
    mobileDrawer: {
        width: 256,
    },
    desktopDrawer: {
        width: 256,
        top: 64,
        height: 'calc(100% - 64px)',
    },
    avatar: {
        cursor: 'pointer',
        width: 64,
        height: 64,
    },
    treeItem: {
        paddingTop: 12,
        fontWeight: 'bold',
    },
    treeLabel: {
        color: theme.palette.text.secondary,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: 14,
    },
}));

const NavBar = ({ onMobileClose, openMobile }) => {
    const classes = useStyles();
    const router = useRouter();
    const { state } = useContext(GlobalContext);

    const handleTreeClick = (tree) => {
        if (tree.children) return;

        if (tree.link) {
            window.open(tree.link, '_blank');
        } else {
            if (tree.type === 1) router.push('/more/' + tree.id + '?page=1');
            router.push('/menus/' + tree.id);
        }
    };

    const content = (
        <Box height="100%" display="flex" flexDirection="column">
            <Box p={2}>
                <List>
                    <Box style={{ marginBottom: 20, marginTop: 10 }} onClick={onMobileClose}>
                        <CloseIcon color="#2F4858" fontSize="medium" />
                    </Box>
                    <TreeView
                        className={classes.tree}
                        defaultCollapseIcon={<ExpandMoreIcon />}
                        defaultExpandIcon={<ChevronRightIcon />}
                        multiSelect={false}
                    >
                        {state.menu.list.map((menu) => {
                            return (
                                <TreeItem
                                    onClick={() => handleTreeClick(menu)}
                                    nodeId={menu.id}
                                    label={menu.name}
                                    key={menu.id}
                                    className={classes.treeItem}
                                    classes={{ label: classes.treeLabel }}
                                >
                                    {menu.children &&
                                        menu.children.map((child) => {
                                            return (
                                                <TreeItem
                                                    onClick={() => handleTreeClick(child)}
                                                    key={child.id}
                                                    nodeId={child.id}
                                                    label={child.name}
                                                    className={classes.treeItem}
                                                    classes={{ label: classes.treeLabel }}
                                                />
                                            );
                                        })}
                                </TreeItem>
                            );
                        })}
                    </TreeView>
                </List>
            </Box>
            <Box flexGrow={1} />
        </Box>
    );

    return (
        <>
            <Hidden lgUp>
                <Drawer
                    anchor="right"
                    classes={{ paper: classes.mobileDrawer }}
                    onClose={onMobileClose}
                    open={openMobile}
                    variant="temporary"
                >
                    {content}
                </Drawer>
            </Hidden>
            <Hidden mdDown>
                <Drawer
                    anchor="left"
                    classes={{ paper: classes.desktopDrawer }}
                    open
                    variant="persistent"
                >
                    {content}
                </Drawer>
            </Hidden>
        </>
    );
};

NavBar.propTypes = {
    onMobileClose: PropTypes.func,
    openMobile: PropTypes.bool,
};

NavBar.defaultProps = {
    onMobileClose: () => {},
    openMobile: false,
};

export default NavBar;
